export const FETCH_BUCKETLIST_DATA_REQUEST = "FETCH_BUCKETLIST_DATA_REQUEST";
export const FETCH_BUCKETLIST_DATA_SUCCESS = "FETCH_BUCKETLIST_DATA_SUCCESS";
export const FETCH_BUCKETLIST_DATA_FAILURE = "FETCH_BUCKETLIST_DATA_FAILURE";
